<template>
  <div class="lesson-share">
    <h5 class="mb-4"><i class="far fa-clipboard mr-2"></i> Pendure Isto</h5>
    <a :href="file" target="_blank">
      <img class="img-fluid" :src="file" />
    </a>
    <div class="d-flex justify-content-end pt-2 position-relative">
      <button class="btn text-primary btn-share" @click="showDialog">
        <i class="fas fa-share-alt"></i>
        COMPARTILHAR
      </button>

      <transition name="fade">
        <div
          v-if="showingDialog"
          v-click-outside="hideDialog"
          class="position-absolute card shadow"
        >
          <div class="card-body">
            <div class="form-row">
              <div
                class="col-lg-4 col-6"
                v-for="network in networks"
                :key="network.network"
              >
                <share-network
                  :network="network.network"
                  class="btn text-light btn-block my-1"
                  :style="{ backgroundColor: network.color }"
                  :url="file"
                  title="Guerrilha way"
                >
                  <small
                    class="d-flex flex-column justify-content-center align-items-center"
                  >
                    <i :class="network.icon"></i>
                    <span>{{ network.name }}</span>
                  </small>
                </share-network>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  directives: {
    ClickOutside
  },
  props: {
    file: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showingDialog: false,
      networks: [
        {
          network: "facebook",
          name: "Facebook",
          icon: "fab fah fa-lg fa-facebook-f",
          color: "#1877f2"
        },
        {
          network: "linkedin",
          name: "LinkedIn",
          icon: "fab fah fa-lg fa-linkedin",
          color: "#007bb5"
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: "fab fah fa-lg fa-whatsapp",
          color: "#25d366"
        },
        {
          network: "pinterest",
          name: "Pinterest",
          icon: "fab fah fa-lg fa-pinterest",
          color: "#bd081c"
        },
        {
          network: "telegram",
          name: "Telegram",
          icon: "fab fah fa-lg fa-telegram-plane",
          color: "#0088cc"
        },
        {
          network: "email",
          name: "Email",
          icon: "far fah fa-lg fa-envelope",
          color: "#333333"
        }
      ]
    };
  },
  methods: {
    showDialog() {
      setTimeout(() => {
        if (!this.showingDialog) {
          this.showingDialog = true;
        }
      }, 300);
    },
    hideDialog() {
      if (this.showingDialog) {
        this.showingDialog = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson-share {
  .btn-share {
    font-size: 12px;
    font-weight: bold;
    display: flex;
    align-items: center;

    i {
      font-size: 16px;
      margin-right: 4px;
    }
  }

  .card {
    z-index: 1;
    top: 50px;
  }
}
</style>
